import debounce from "lodash.debounce";
import { Middleware } from "redux";

import { CandyDispatch, CandyThunkAction } from "../../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormAction } from "../../../../Engine/Core/Store/FullFormAction";

import { CrossFitTableActionType, CrossFitTableColumnGroupingAction } from "./crossFitTableActions";

export function crossFitTableMiddleware(): Middleware {
    const result =
        () =>
        (next: CandyDispatch): CandyDispatch => {
            let actionBatch: CrossFitTableColumnGroupingAction[] = [];
            let isFirstAction = true;

            function flushBatch(): void {
                const actionBatchToProcess = actionBatch;
                actionBatch = [];
                if (actionBatchToProcess.length > 0) {
                    next({
                        type: CrossFitTableActionType.ColumnGroupingBatch,
                        payload: { events: actionBatchToProcess },
                    });
                }
            }

            const flushTrottled = debounce(flushBatch, 1000);
            const enableThrottling = debounce(() => {
                isFirstAction = false;
            }, 500);

            return <R>(action: FullFormAction | CandyThunkAction<R>): R | void => {
                if (typeof action === "function") {
                    return next(action);
                }
                if (isFirstAction) {
                    const actionResult = next(action);
                    enableThrottling();
                    return actionResult;
                } else {
                    if (action.type === CrossFitTableActionType.SetColumnGrouping) {
                        actionBatch.push(action);
                        if (action.payload.doNotThrottle) {
                            flushBatch();
                        } else {
                            flushTrottled();
                        }
                        return undefined;
                    } else if (action.type === CrossFitTableActionType.SetHiddenColumnGrouping) {
                        actionBatch.push(action);
                        if (action.payload.doNotThrottle) {
                            flushBatch();
                        } else {
                            flushTrottled();
                        }
                        return undefined;
                    } else {
                        return next(action);
                    }
                }
            };
        };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-explicit-any
    return result as any;
}
